/* eslint-disable max-len */
import type { IconPrimitiveProps } from 'types';

const IconBrandFreshful = (props: IconPrimitiveProps) => {
  const {
    size = 24,
    ...rest
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={size}
      height={size}
      {...rest}
    >
      <path fill="red" d="M7.18 6.874H4.269V4.54a1.174 1.174 0 0 1 1.168-1.171 1.678 1.678 0 0 0 1.68-1.684A1.686 1.686 0 0 0 5.437 0c-1.2.001-2.352.48-3.2 1.331A4.55 4.55 0 0 0 .907 4.539v2.524A1.681 1.681 0 0 0 0 8.558a1.687 1.687 0 0 0 .908 1.496v2.262A1.686 1.686 0 0 0 2.588 14a1.678 1.678 0 0 0 1.68-1.684v-2.073H7.18a1.678 1.678 0 0 0 1.68-1.684 1.686 1.686 0 0 0-1.68-1.684Z" />
      <path fill="green" d="M11.225 8.404c-1.486 0-2.69-.85-2.69-1.896 0-1.048 1.204-1.896 2.69-1.896 1.487 0 2.691.848 2.691 1.896 0 1.047-1.204 1.896-2.69 1.896Zm.407-6.225a1.391 1.391 0 0 0-.375 1.282 1.386 1.386 0 0 0 1.63-.968c.066-.225.074-.462.024-.69a1.384 1.384 0 0 0-1.279.376Zm-.813.752a1.388 1.388 0 0 0-1.28-.375 1.395 1.395 0 0 0 .967 1.634c.223.065.46.074.687.024a1.394 1.394 0 0 0-.374-1.283Z" />
    </svg>
  );
};
export default IconBrandFreshful;
